import { PlayersStatsTableItem } from "../../../types/player";
import { FCRodinaTable as Table } from "../../Table";
import { TablePlayerName } from "../../Table/PlayerName";

interface PlayersStatsMiniTableProps {
    data: PlayersStatsTableItem[];
}

export const PlayersStatsMiniTable: React.FC<PlayersStatsMiniTableProps> = ({ data }) => {
    const dataColumns = [
        { title: 'Игрок', dataIndex: 'name', key: 'name', left: true },
        { title: 'Г', dataIndex: 'goals', key: 'goals' },
        { title: 'А', dataIndex: 'assists', key: 'assists' },
    ];

    const dataItems = data.map((item) => {
        return dataColumns.map((column) => {
            const value = item[column.dataIndex];
            if (column.dataIndex === 'name') {
                return {
                    key: column.key,
                    value: (
                        <TablePlayerName photoUrl={item.photo} name={value} url={item.url} />
                    )
                }
            }
            return {
                key: column.key,
                value
            }
        });
    });

    return (
        <Table
            columns={dataColumns}
            data={dataItems}
            rowClass="text-lg sm:text-xl"
            cellClass="!min-w-9"
        />
    );
}

